/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Shipping_DateInputs */

const en_orders_shipping_date = /** @type {(inputs: Orders_Shipping_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipping Date`)
};

const es_orders_shipping_date = /** @type {(inputs: Orders_Shipping_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de envio`)
};

/**
* | output |
* | --- |
* | "Shipping Date" |
*
* @param {Orders_Shipping_DateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_shipping_date = /** @type {((inputs?: Orders_Shipping_DateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Shipping_DateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_shipping_date(inputs)
	return es_orders_shipping_date(inputs)
});